let cachedIP: string | null = null;
let isFlushing = false;
const outletCode = localStorage.getItem("outlet-code") || "-";

export const getPublicIP = async (): Promise<string> => {
  if (cachedIP) return cachedIP;
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    cachedIP = data.ip;
    return data.ip;
  } catch {
    return "UNKNOWN";
  }
};

export const enqueueLog = async (logData: any) => {
  try {
    const logs = JSON.parse(localStorage.getItem("logQueue") || "[]");
    const isSelfLog = logData.url?.includes("/api/pos-order/outlet-service/log");
    if (isSelfLog) {
      const alreadyHasSelfLog = logs.some((l: any) => l.url?.includes("/api/pos-order/outlet-service/log"));
      if (alreadyHasSelfLog) {
        console.warn("Skipped duplicate self-log (endpoint log).");
        return;
      }
    }

    logs.push({ ...logData, createdAt: Date.now() });
    localStorage.setItem("logQueue", JSON.stringify(logs));

    console.log("Log queued:", logData, isSelfLog, logs);
  } catch (e) {
    console.error("Failed to queue log:", e);
  }
};

export const flushQueue = async () => {
  const ip = await getPublicIP();
  if (isFlushing) {
    console.warn("Flush already in progress...");
    return;
  }

  const tokenRaw = localStorage.getItem("token");
  const token = tokenRaw ? JSON.parse(tokenRaw) : null;
  if (!token?.access) {
    console.warn("No token, skipping flush");
    return;
  }

  isFlushing = true;

  try {
    const logs: any[] = JSON.parse(localStorage.getItem("logQueue") || "[]");
    if (!logs.length) {
      console.warn("No logs to flush");
      return;
    }

    const failedLogs: any[] = [];

    for (let i = 0; i < logs.length; i++) {
      const log = logs[i];
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/pos-order/outlet-service/log`, {
          method: "POST",
          headers: {
            Authorization: `${token.type} ${token.access}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(log),
        });

        if (!res.ok) {
          console.warn("Failed to send log:", res.status, await res.text());
          enqueueLog({
            url: `${process.env.REACT_APP_API_URL}/api/pos-order/outlet-service/log`,
            subject: "SEND_LOG",
            outlet_code: outletCode,
            request: "{}",
            ip,
            response_status: res.status,
            response: await res.text(),
            user_agent: navigator.userAgent,
          });
        }
      } catch (e) {
        console.warn("Failed to send log:", e);
        enqueueLog({
          url: `${process.env.REACT_APP_API_URL}/api/pos-order/outlet-service/log`,
          subject: "SEND_LOG",
          outlet_code: outletCode,
          request: "{}",
          ip,
          response_status: "FETCH_ERROR",
          response: "CAN'T SEND REQUEST",
          user_agent: navigator.userAgent,
        });
      }
    }

    if (failedLogs.length) {
      localStorage.setItem("logQueue", JSON.stringify(failedLogs));
      console.warn(`${failedLogs.length} logs failed, kept in queue`);
    } else {
      localStorage.removeItem("logQueue");
      console.info("All logs flushed successfully");
    }
  } finally {
    isFlushing = false;
  }
};
